import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Privacy = () => {

    const {t} = useTranslation('home');

  return (
    <div className="container text-center" style={{ padding: '100px 0' }}>
      <h1 className="display-4 mt-5 mb-3">{t('privacy-policy')}</h1>
      <p className="lead mb-5 mt-5">{t('privacy-1')}</p>
      <p className="lead mb-5 mt-5">{t('privacy-2')}</p>
      <p className="lead mb-5 mt-5">{t('privacy-3')}</p>
      <p className="lead mb-5 mt-5">{t('privacy-4')}</p>
      <p className="lead mb-5 mt-5">{t('privacy-5')}</p>
      <p className="lead mb-5 mt-5">{t('privacy-6')}</p>
    

      <Link to="/" className="btn btn-outline-primary">
        Go Back Home
      </Link>
    </div>
  );
};

export default Privacy;
